import { getStoredAuthToken } from "./authHeaders";

export const isAuthenticated = () => {
  const user = localStorage.getItem("user");
  return user;
};

export const isAdminAuthenticated = () => {
  return Boolean(getStoredAuthToken());
}